import { Content, Lesson, Program, User, SectionFragment } from '../types';

const views = {
  mainDashboard: 'main_dashboard_view',
  dashboard: 'dashboard_view',
  userProfile: 'user_profile_view',
  users: 'users_page_view',
  exitTicketReports: 'exit_ticket_reports_view',
  standaloneLessons: 'standalone_lessons_view',
  gettingStarted: 'getting_started_view',
};

const actions = {
  courseCollapsed: 'course_collapsed',
  courseOpened: 'course_open',
  courseLessonOpen: 'course_lesson_open',
  teacherPreparationOpen: 'teacher_preparation_open',
  contentOpened: 'content_opened',
  unitOpen: 'unit_open',
  startUnit: 'unit_started',
  courseMaterials: 'course_materials',
  lessonOpened: 'lesson_open',
  sectionOpened: 'section_open',
  previewLessonModulesViewed: 'preview_lesson_modules_viewed',
  lessonModulesViewed: 'lesson_modules_viewed',
  lessonCompleted: 'lesson_completed',
  sectionCompleted: 'section_completed',
  exitLesson: 'exit_lesson',
  exitSection: 'exit_section',
  playPreviewVideo: 'play_preview_video',
  allLessonsCompletedInUnit: 'all_lessons_completed_in_unit',
  lessonPreviewOpen: 'lesson_preview_open',
  resumeButtonPressed: 'resume_button_pressed',
  surveySubmitted: 'survey_submitted',
  logIn: 'log_in',
  logInFailed: 'log_in_failed',
  logOut: 'log_out',
  userProfileUpdated: 'user_profile_updated',
  fbCommunityOpened: 'fb_community_opened',
  contentContinueButtonPressed: 'continue_button_pressed',
  courseButtonResumePressed: 'resume_button_pressed',
  videoWatched: 'video_watched',
  userRemoved: 'user_removed',
  surveyFormLinkCreated: 'survey_form_link_created',
  surveyFormSubmitted: 'survey_form_submitted',
  parentLoggedIn: 'parent_logged_in',
  educatorWellbeingUnitOpen: 'educator_wellbeing_unit_open',
  educatorWellbeingUnitLessonOpen: 'educator_wellbeing_unit_lesson_open',
  userIntentionWhenRegister: 'user_intention',
  userPositionWhenRegister: 'position',
  standaloneLessonOpen: 'standalone_lesson_open',
  standaloneLessonPreviewOpen: 'standalone_lesson_preview_open',
  standaloneLessonCompleted: 'standalone_lesson_completed',
  preProgramQuizOpen: 'pre_program_quiz_open',
  extensionLessonStarted: 'extension_exercise_completed',
  lessonMaterials: 'lesson_materials',
  lessonLibrarySearch: 'LessonLibrarySearch',
};

const mappers = {
  program: (program: Program | undefined) => {
    if (!program) return;
    return {
      course_name: program.name ?? '',
    };
  },
  lesson: (lesson: Lesson | SectionFragment | undefined) => {
    if (!lesson) return;
    return {
      lesson_name: lesson.name ?? '',
    };
  },
  content: (content: Content | undefined) => {
    if (!content) return;
    return {
      content_name: content.name ?? '',
    };
  },
  user: (user: User | undefined) => {
    if (!user) return;
    return {
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      email: user.email ?? '',
      country: user.customer?.country ?? '',
      schoolId: user?.schools?.[0]?.id,
      schoolName: user?.schools?.[0]?.name,
      userId: user?.id,
      userName: `${user?.firstName} ${user?.lastName}`,
    };
  }
};

export const Events = {
  views,
  actions,
  mappers,
};
